module.exports = __webpack_public_path__ + "img/Filter2.9acfc52f.svg";